import { Component, OnInit } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { ReportService } from "../../../../Report/report.service";

@Component({
	selector: "app-group-print-point-options",
	templateUrl: "./group-print-point-options.component.html",
	styleUrls: ["./group-print-point-options.component.css"],
})
export class GroupPrintPointOptionsComponent implements OnInit {
	constructor(private reportService: ReportService, private ref: DynamicDialogRef, private dialogConfig: DynamicDialogConfig) {}

	ngOnInit(): void {
		this.SchoolID = this.dialogConfig.data.SchoolID;

		this.loadLogolist();
	}

	////////////////////////////////////
	// Data
	////////////////////////////////////

	SchoolID: any;

	OrderByOption: any = "Date";
	lstOrderByOption: any = [
		{
			ID: "Date",
			Desc: "Date",
		},
		{
			ID: "PointsItemDesc",
			Desc: "Point Description",
		},
		{
			ID: "PointsTransactionType",
			Desc: "Transaction Type",
		},
		{
			ID: "PointsItemValue",
			Desc: "Value",
		},
	];

	ImageLoading: boolean = true;
	ImageLogo: any;
	lstImageLogo: any = [];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];
	////////////////////////////////////

	////////////////////////////////////
	// Load Data
	////////////////////////////////////

	private loadLogolist() {
		this.ImageLoading = true;

		var result = this.reportService.ImageLogoGetList("", this.SchoolID);
		result.subscribe(
			(response) => {
				this.lstImageLogo = response;

				this.ImageLogo = this.lstImageLogo[0].ImageLibraryID;

				this.ImageLoading = false;
			},
			(error) => {
				this.ImageLoading = false;
			}
		);
	}

	////////////////////////////////////

	////////////////////////////////////
	// Buttons
	////////////////////////////////////

	onClose() {
		this.ref.close(0);
	}

	onContinue() {
		var ans: any = {
			OrderByOption: this.OrderByOption,
			ImageLogo: this.ImageLogo,
			OutputTypeID: this.OutputTypeID,
		};

		this.ref.close(ans);
	}

	////////////////////////////////////

	////////////////////////////////////
	// Helpers
	////////////////////////////////////

	IsLoading() {
		return this.ImageLoading == true;
	}

	////////////////////////////////////
}
